export const songs = [
  {
    stage: 1,
    quizInfo: [
      {
        id: 1,
        name: 'Q_Hardkiss_Juravli',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Hardkiss_Juravli.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Hardkiss_Juravli.mp3',
        correctSinger: {
          song: 'THE HARDKISS',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Lady Gaga',
          },
          {
            song: 'Queen',
          },
          {
            song: 'The Beatles',
          },
          {
            song: 'Rammstein',
          },
          {
            song: 'Michael Jackson',
          },
          {
            song: 'Madonna',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_Wellboy_Guci',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Wellboy_Guci.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Wellboy_Guci.mp3',
        correctSinger: {
          song: 'Wellboy',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Whitney Houston',
          },
          {
            song: 'Britney Spears',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'Christina Aguilera',
          },
          {
            song: 'Rihanna',
          },
          {
            song: 'Justin Timberlake',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_Odin_v_kanoe_Poobicyai_meni',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Odin_v_kanoe_Poobicyai_meni.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Odin_v_kanoe_Poobicyai_meni.mp3',
        correctSinger: {
          song: 'Один в каное',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Shakira',
          },
          {
            song: 'Beyoncé',
          },
          {
            song: 'Robbie Williams',
          },
          {
            song: 'ABBA',
          },
          {
            song: 'Elton John',
          },
          {
            song: 'Sting',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_Fiolet_Kohana',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Fiolet_Kohana.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Fiolet_Kohana.mp3',
        correctSinger: {
          song: 'Фіолет',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Jennifer Lopez',
          },
          {
            song: 'Backstreet Boys',
          },
          {
            song: 'Taylor Swift',
          },
          {
            song: 'Duran Duran',
          },
          {
            song: 'Céline Dion',
          },
          {
            song: 'Lana Del Rey',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_Skryabin_Stari_Foto',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Skryabin_Stari_Foto.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Skryabin_Stari_Foto.mp3',
        correctSinger: {
          song: 'Скрябін',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Pink',
          },
          {
            song: 'Spice Girls',
          },
          {
            song: 'David Bowie',
          },
          {
            song: 'Cher',
          },
          {
            song: 'John Lennon',
          },
          {
            song: 'Eminem',
          },
        ],
      },
    ],
  },
  {
    stage: 2,
    quizInfo: [
      {
        id: 1,
        name: 'Q_100Litsya_Skyler_Vechornutsi',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_100Litsya_Skyler_Vechornutsi.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/100Litsya_Skyler_Vechornutsi.mp3',
        correctSinger: {
          song: '100лиця / SKYLERR',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Skofka',
          },
          {
            song: 'Chico / Qatoshi',
          },
          {
            song: 'KALUSH feat. Jerry Heil',
          },
          {
            song: 'Океан Ельзи',
          },
          {
            song: 'Alina Pash',
          },
          {
            song: 'DZIDZIO feat Оля Цибульська',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_Chico_Qatoshi_Lastivki',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Chico_Qatoshi_Lastivki.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Chico_Qatoshi_Lastivki.mp3',
        correctSinger: {
          song: 'Chico / Qatoshi',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Скрябін',
          },
          {
            song: '100лиця / SKYLERR',
          },
          {
            song: 'O.Torvald',
          },
          {
            song: "Мотор'Ролла",
          },
          {
            song: 'Skofka',
          },
          {
            song: 'Океан Ельзи',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_Cheev_Garno_Tak',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Cheev_Garno_Tak.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Cheev_Garno_Tak.mp3',
        correctSinger: {
          song: 'CHEEV',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'MamaRika',
          },
          {
            song: 'alyona alyona / Alina Pash',
          },
          {
            song: 'Олег Винник',
          },
          {
            song: 'Vivienne Mort',
          },
          {
            song: 'Wellboy',
          },
          {
            song: 'Jerry Heil',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_Skofka_Chuty_gimn',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Skofka_Chuty_gimn.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Skofka_Chuty_gimn.mp3',
        correctSinger: {
          song: 'Skofka',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Димна Суміш',
          },
          {
            song: 'МАША КОНДРАТЕНКО',
          },
          {
            song: 'KALUSH feat. Jerry Heil',
          },
          {
            song: 'Олег Винник',
          },
          {
            song: 'Бумбокс',
          },
          {
            song: 'KALUSH',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_Kola_Chi_razom',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Kola_Chi_razom.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Kola_Chi_razom.mp3',
        correctSinger: {
          song: 'KOLA',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Олег Винник',
          },
          {
            song: 'Ed Sheeran (feat. Antytila)',
          },
          {
            song: 'Арсен Мірзоян',
          },
          {
            song: 'Один в каное',
          },
          {
            song: 'O.Torvald',
          },
          {
            song: 'Skofka',
          },
        ],
      },
    ],
  },
  {
    stage: 3,
    quizInfo: [
      {
        id: 1,
        name: 'Q_Rysya_Zaryuhena',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Rysya_Zaryuhena.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Rysya_Zaryuhena.mp3',
        correctSinger: {
          song: 'Руся',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Олег Винник',
          },
          {
            song: 'KALUSH',
          },
          {
            song: 'MamaRika',
          },
          {
            song: 'CHEEV',
          },
          {
            song: 'LATEXFAUNA',
          },
          {
            song: 'Один в каное',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_JeryHeil_alyonaalyona_Ela_Kupala',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_JeryHeil_alyonaalyona_Ela_Kupala.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/JeryHeil_alyonaalyona_Ela_Kupala.mp3',
        correctSinger: {
          song: 'Jerry Heil / alyona alyona / Ela.',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'MamaRika',
          },
          {
            song: 'Ed Sheeran (feat. Antytila)',
          },
          {
            song: 'CHEEV',
          },
          {
            song: 'Океан Ельзи',
          },
          {
            song: 'МЮСЛІ UA ft. Vasia Charisma',
          },
          {
            song: 'Один в каное',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_Shumei_Probach',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Shumei_Probach.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Shumei_Probach.mp3',
        correctSinger: {
          song: 'SHUMEI',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'KALUSH feat. Jerry Heil',
          },
          {
            song: 'THE HARDKISS',
          },
          {
            song: 'Один в каное',
          },
          {
            song: 'Skofka',
          },
          {
            song: 'MamaRika',
          },
          {
            song: 'Океан Ельзи',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_Wellboy_VorogivNaNogi',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Wellboy_VorogivNaNogi.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Wellboy_VorogivNaNogi.mp3',
        correctSinger: {
          song: 'Wellboy',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'KOLA',
          },
          {
            song: 'YARMAK',
          },
          {
            song: 'Бумбокс',
          },
          {
            song: 'Арсен Мірзоян',
          },
          {
            song: 'Океан Ельзи',
          },
          {
            song: 'Vivienne Mort',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_Skofka_NeZabudemINeProbachym',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Skofka_NeZabudemINeProbachym.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Skofka_NeZabudemINeProbachym.mp3',
        correctSinger: {
          song: 'Skofka',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Тінь Сонця',
          },
          {
            song: 'Скрябін',
          },
          {
            song: 'SHUMEI',
          },
          {
            song: 'Один в каное',
          },
          {
            song: '100лиця / SKYLERR',
          },
          {
            song: 'CHEEV',
          },
        ],
      },
    ],
  },
  {
    stage: 4,
    quizInfo: [
      {
        id: 1,
        name: 'Q_Vinnyk_Vovchitsya',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Vinnyk_Vovchitsya.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Vinnyk_Vovchitsya.mp3',
        correctSinger: {
          song: 'Олег Винник',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Skofka',
          },
          {
            song: 'KALUSH feat. Jerry Heil',
          },
          {
            song: 'KALUSH feat. Skofka',
          },
          {
            song: 'Ed Sheeran (feat. Antytila)',
          },
          {
            song: 'Wellboy',
          },
          {
            song: 'Паліндром',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_Shumei_Bilya_topoli',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Shumei_Bilya_topoli.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Shumei_Bilya_topoli.mp3',
        correctSinger: {
          song: 'SHUMEI',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'O.Torvald',
          },
          {
            song: 'Chico / Qatoshi',
          },
          {
            song: 'Олег Винник',
          },
          {
            song: 'KALUSH',
          },
          {
            song: '100лиця / SKYLERR',
          },
          {
            song: 'Wellboy',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_Enleo_Insha_lubov',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Enleo_Insha_lubov.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Enleo_Insha_lubov.mp3',
        correctSinger: {
          song: 'ENLEO',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Ed Sheeran (feat. Antytila)',
          },
          {
            song: 'Monatik',
          },
          {
            song: 'МАША КОНДРАТЕНКО',
          },
          {
            song: 'CHEEV',
          },
          {
            song: 'Океан Ельзи',
          },
          {
            song: 'Фіолет',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_MusliUA_DobryiDenEverybody',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_MusliUA_DobryiDenEverybody',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/MusliUA_DobryiDenEverybody.mp3',
        correctSinger: {
          song: 'МЮСЛІ UA ft. Vasia Charisma',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Wellboy',
          },
          {
            song: 'ENLEO',
          },
          {
            song: 'KALUSH ft. Христина Соловій',
          },
          {
            song: 'Димна Суміш',
          },
          {
            song: 'Фіолет',
          },
          {
            song: 'Один в каное',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_M_Kondratenko_VankaVstanka',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_M_Kondratenko_VankaVstanka.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/M_Kondratenko_VankaVstanka.mp3',
        correctSinger: {
          song: 'МАША КОНДРАТЕНКО',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Курган / Agregat feat. Vovking і Tapolsky',
          },
          {
            song: 'ENLEO',
          },
          {
            song: 'Wellboy',
          },
          {
            song: 'KALUSH feat. Jerry Heil',
          },
          {
            song: 'MamaRika',
          },
          {
            song: 'Сальто Назад',
          },
        ],
      },
    ],
  },
  {
    stage: 5,
    quizInfo: [
      {
        id: 1,
        name: 'Q_Pivovarov_dorofeeva_Dumi',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Pivovarov_dorofeeva_Dumi.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Pivovarov_dorofeeva_Dumi.mp3',
        correctSinger: {
          song: 'Artem Pivovarov / DOROFEEVA',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'THE HARDKISS',
          },
          {
            song: 'Мері',
          },
          {
            song: 'Один в каное',
          },
          {
            song: 'The unsleeping',
          },
          {
            song: 'Бумбокс',
          },
          {
            song: '100лиця / SKYLERR',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_EdSheeran_Antytila_2step',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_EdSheeran_Antytila_2step.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/EdSheeran_Antytila_2step.mp3',
        correctSinger: {
          song: 'Ed Sheeran (feat. Antytila)',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Тінь Сонця',
          },
          {
            song: 'KALUSH ft. Христина Соловій',
          },
          {
            song: '100лиця / SKYLERR',
          },
          {
            song: 'ENLEO',
          },
          {
            song: 'Олег Винник',
          },
          {
            song: 'Skofka',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_EngyKreyda_Vrage',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_EngyKreyda_Vrage.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/EngyKreyda_Vrage.mp3',
        correctSinger: {
          song: 'Енджі Крейда',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Skofka',
          },
          {
            song: 'SKRYAGA',
          },
          {
            song: 'Мері',
          },
          {
            song: 'СКАЙ',
          },
          {
            song: 'Руся',
          },
          {
            song: 'Chico / Qatoshi',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_Chico_Qatoshi_DopomogeZSU',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Chico_Qatoshi_DopomogeZSU.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Chico_Qatoshi_DopomogeZSU.mp3',
        correctSinger: {
          song: 'Chico / Qatoshi',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'СКАЙ',
          },
          {
            song: 'Мері',
          },
          {
            song: 'Artem Pivovarov / DOROFEEVA',
          },
          {
            song: 'CHEEV',
          },
          {
            song: 'МАША КОНДРАТЕНКО',
          },
          {
            song: 'Океан Ельзи',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_OE_KvityMinnyhZon',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_OE_KvityMinnyhZon.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/OE_KvityMinnyhZon.mp3',
        correctSinger: {
          song: 'Океан Ельзи',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Христина Соловій',
          },
          {
            song: 'CHEEV',
          },
          {
            song: 'Тарас Чубай та Плач Єремії',
          },
          {
            song: 'Karna',
          },
          {
            song: 'СКАЙ',
          },
          {
            song: 'Енджі Крейда',
          },
        ],
      },
    ],
  },
];
